export const formatPercent = (value) => {
  if (value === null || value === undefined) return "";

  const number = parseFloat(value);
  if (isNaN(number)) return "";

  return new Intl.NumberFormat("es-CL", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number) + " %";
};
